const config = {
  env: 'local',
  // apiUrl: "http://localhost:5542/admin/",
   apiUrl: "https://api.eurobridge.in/admin/",
  // shipRocketApiUrl: "https://apiv2.shiprocket.in/v1/external/"
}

export default config;
